<template>
    <div class="body back-gray" v-if="is_loading">
        <div class="wrap txt-center intro">
            <h1 class="mt-20">
                각 파트에는 주어진<br>제한시간이 있습니다.
            </h1> 
            
            <div class="setting-box txt-left">
                <!-- ⓐ  Part Ⅰ 빈 칸 채우기 - <span class="bold">{{guide_info[0].time}}</span><br>
                ⓑ  Part Ⅱ 주어진 단어로 문장 완성하기 - <span class="bold">{{guide_info[1].time}}</span><br>
                ⓒ  Part Ⅲ 주어진 국문 영작하기 - <span class="bold">{{guide_info[2].time}}</span><br>
                ⓓ  Part Ⅳ 주어진 사진 묘사하기 - <span class="bold">{{guide_info[3].time}}</span><br>
                ⓔ  Part Ⅴ 대화 듣고 요약하기 - <span class="bold">{{guide_info[4].time}}</span><br>
                ⓕ  Part Ⅵ E-mail 작성하기 - <span class="bold">{{guide_info[5].time}}</span> -->

                Part Ⅰ 빈 칸 채우기 - <span class="bold">{{guide_info[0].time}}</span><br>
                Part Ⅱ 주어진 단어로 문장 완성하기 - <span class="bold">{{guide_info[1].time}}</span><br>
                Part Ⅲ 주어진 국문 영작하기 - <span class="bold">{{guide_info[2].time}}</span><br>
                Part Ⅳ 주어진 사진 묘사하기 - <span class="bold">{{guide_info[3].time}}</span><br>
                Part Ⅴ 대화 듣고 요약하기 - <span class="bold">{{guide_info[4].time}}</span><br>
                Part Ⅵ E-mail 작성하기 - <span class="bold">{{guide_info[5].time}}</span>
            </div>
        </div>        
        <div class="wrap">
            <div class="btn-fixed">
                <button class="btn-full" @click="next()">NEXT</button>
            </div>
        </div>
        <!-- 푸터 -->
        <Footer></Footer>
    </div>
</template>
<script>
import Footer from '@/components/footer.vue';
export default {
    name: 'Setting03',
    components: {
        Footer
    },
    data: () => ({
        is_loading:false,
        guide_info:{}
    }),
    mounted() {
        this.getModule();
    },
    methods: {
        getModule(){
           var params = {
               idx : sessionStorage.getItem("student_idx")
           }
           this.axios.get(this.axios.root + "/rest/module_info/getModuleInfos",{params:params}).then((res)=>{
                if(res.data.err == 0){
                    this.guide_info = res.data.module_info.guide_info;
                    for(var i = 0; i < this.guide_info.length; i++){
                        this.guide_info[i].time = this.covertSeconds(this.guide_info[i].second);
                    }
                    this.is_loading = true;
                }else if(res.data.err == 5000){
                    alert(res.data.err_msg);
                    sessionStorage.clear();
                    location.href="/intro";
                }else{
                    alert(res.data.err_msg);
                    return false;
                }
           })
        },
        covertSeconds(seconds){
            if (seconds < 60) {
                return seconds + '초';
            } else if (seconds < 3600){
                return Math.floor(seconds%3600/60) + '분 ' + seconds%60 + '초';
            } else {
                return Math.floor(seconds/3600) + '시간 ' + Math.floor(seconds%3600/60) + '분 ' + seconds%60 + '초';
            }
        },
        next(){
            location.href ='/setting04'
        }

    }
}
</script>